<template>
  <div>
    <b-card v-if="data.user.full_name">
      <div class="media-list media-bordered" ref="comments">
        <b-media>
          <template #aside>
            <b-avatar rounded size="42" :src="data.user.profile_image_path" />
          </template>

          <h5 class="mt-0">{{ data.user.full_name }}</h5>
          <b-card-text>{{ data.created_at }}</b-card-text>
          <b-card-text>
            <span v-if="data.type == 'text'" v-html="data.content"> </span>
            <span v-if="data.type == 'audio'">
              <audio controls :src="data.meida_data"></audio>
            </span>
            <span v-if="data.type == 'video'">
              <video
                width="400"
                height="250"
                controls
                :src="data.meida_data"
              ></video
            ></span>
          </b-card-text>

          <b-media
            class="mt-3"
            v-for="children in data.replies"
            :key="children.id"
          >
            <template #aside>
              <b-avatar
                rounded
                size="42"
                :src="children.user.profile_image_path"
              />
            </template>

            <h5 class="mt-0">{{ children.user.full_name }}</h5>
            <b-card-text>{{ children.created_at }}</b-card-text>
            <b-card-text class="mb-0">
              <span v-if="children.type == 'text'" v-html="children.content">
              </span>
              <span v-if="children.type == 'audio'">
                <audio controls :src="children.meida_data"></audio>
              </span>
              <span v-if="children.type == 'video'">
                <video
                  width="400"
                  height="250"
                  controls
                  :src="children.meida_data"
                ></video
              ></span>
            </b-card-text>
          </b-media>
        </b-media>
      </div>
      <!-- Leave a Blog Comment -->
      <hr />
      <b-col cols="12" class="mt-2">
        <h6 class="section-label">{{ $t("comment.leave_comment") }}</h6>
        <b-card>
          <b-form>
            <b-row>
              <b-col cols="12">
                <b-tabs content-class="pt-1" fill v-model="commentTab">
                  <b-tab :title="$t('comment.text')">
                    <b-form-group class="mb-2">
                      <b-form-textarea
                        name="textarea"
                        v-model="newItem.content"
                        rows="4"
                        :placeholder="$t('comment.comment')"
                      />
                    </b-form-group>
                  </b-tab>
                  <b-tab :title="$t('comment.audio')">
                    <b-row>
                      <b-col lg="6">
                        <vue-record-audio @result="onResult" />
                      </b-col>
                      <b-col lg="6">
                        <div ref="soundClips"></div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab :title="$t('comment.video')">
                    <b-row>
                      <b-col lg="6">
                        <vue-record-video
                          thumbnail
                          fluid
                          mode="press"
                          @stream="onVideoStream"
                          @result="onVideoResult"
                          style="
                            z-index: 1000;
                            position: absolute;
                            padding-top: 89px;
                            padding-right: 163px;
                          "
                        />
                        <video
                          ref="SVideo"
                          width="400"
                          height="250"
                          playsinline
                          autoplay
                          muted
                        ></video>
                      </b-col>

                      <b-col lg="6">
                        <video
                          ref="Video"
                          width="400"
                          height="250"
                          controls
                        ></video>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col cols="9">
                <b-button variant="primary" @click="addComment()">
                  {{ $t("comment.add_comment") }}
                </b-button>
              </b-col>

              <b-col cols="3" class="float-right">
                <b-button variant="info" @click="exportToPDF">
                  {{ $t("comment.export_to_PDF") }}</b-button
                >
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
      <!--/ Leave a Blog Comment -->
    </b-card>
  </div>
</template>

<script>
import controller from "@/Controllers/DiscussionsController";
import Auth from "@/Apis/Auth";
import html2pdf from "html2pdf.js";

let ctx = new controller();

export default {
  data() {
    return {
      data: {},
      newItem: {},
      commentTab: 0,
      meidaData: null,
      stream: false,
    };
  },

  async created() {
    this.data = await ctx.Show(this.$route.params.id);
  },
  methods: {
    async addComment() {
      this.newItem.type = "text";
      if (this.commentTab == 1) {
        this.newItem.type = "audio";
      }
      if (this.commentTab == 2) {
        this.newItem.type = "video";
      }
      this.newItem.edu_program_id = localStorage.getItem("eduProgram");
      this.newItem.user_id = Auth.USER.id;
      this.newItem.titel = "";
      this.newItem.parent_id = this.data.id;
      this.newItem.meidaData = this.meidaData;

      const [ret, show] = await Promise.all([
        ctx.From(this.newItem, "FormData"),
        ctx.Show(this.$route.params.id),
      ]);
      this.data = show;
      this.newItem = {};
    },
    exportToPDF() {
      html2pdf(this.$refs.comments, {
        margin: 1,
        filename: "comments.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      });
    },
    onResult(data) {
      var audio = document.createElement("audio");
      audio.setAttribute("controls", "");
      if (this.$refs.soundClips.lastChild)
        this.$refs.soundClips.removeChild(this.$refs.soundClips.lastChild);
      this.$refs.soundClips.appendChild(audio);
      audio.controls = true;
      audio.src = URL.createObjectURL(data);
      this.meidaData = data;
    },
    onVideoStream(stream) {
      this.stream = true;
      this.$refs.SVideo.srcObject = stream;
    },
    onVideoResult(data) {
      this.stream = false;
      this.$refs.Video.srcObject = null;
      this.$refs.Video.src = window.URL.createObjectURL(data);
      this.meidaData = data;
    },
  },
};
</script>
